import { MultiplierAnimationConfig } from '@Animation/types'
import { preLoadAssets } from './asset-preloader'
import { MichiganPuttingMultiplierAnimation } from './mi-putting-multiplier-animation'

export const MI_MULTIPLIER_PUTTING_CONFIG: MultiplierAnimationConfig = {
  assetPreloader: preLoadAssets,
  revealAnimation: MichiganPuttingMultiplierAnimation,
}
